export default __webpack_public_path__ + "static/media/brazil-flag.a4ed57ec.png";